import { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface SwipeContextType {
  openCardId: string | null;
  setOpenCardId: (id: string | null) => void;
  closeAll: () => void;
}

const SwipeContext = createContext<SwipeContextType | undefined>(undefined);

export const SwipeProvider = ({ children }: { children: ReactNode }) => {
  const [openCardId, setOpenCardId] = useState<string | null>(null);

  const closeAll = useCallback(() => {
    setOpenCardId(null);
  }, []);

  return (
    <SwipeContext.Provider value={{ openCardId, setOpenCardId, closeAll }}>
      {children}
    </SwipeContext.Provider>
  );
};

export const useSwipeContext = () => {
  const context = useContext(SwipeContext);
  if (!context) {
    throw new Error("useSwipeContext must be used within a SwipeProvider");
  }
  return context;
};
